module.exports = __webpack_public_path__ + "img/img_017@2x.845a57f1.png";